    // Metafield-based Upsell functionality

    const STAY_SELLING_PLAN_ID = window.FDMinicartUpsellsConfig.staySellingPlanId;
    const ADD_ON_SUBSCRIPTION_PLAN_ID = window.FDMinicartUpsellsConfig.addOnSubscriptionPlanId;
    const EMPTY_CART_UPSELL_HANDLES = window.FDMinicartUpsellsConfig.emptyCartUpsellHandles || [];
    const EMPTY_CART_UPSELL_MAX_COUNT = window.FDMinicartUpsellsConfig.emptyCartUpsellMaxCount;
    const EMPTY_CART_UPSELL_PRODUCTS = window.FDMinicartUpsellsConfig.emptyCartUpsellProducts || {};
    const MINICART_GLOBAL_COUPON_CODE = window.FDMinicartUpsellsConfig.globalCouponCode;
    // Non-stacked upsell-card discount rates from Global Pricing & Subscription
    // (Theme settings → Global Pricing & Subscription).
    const UPSELL_SUB_DISCOUNT_PCT = window.FDMinicartUpsellsConfig.upsellSubDiscountPct;
    const UPSELL_OTP_DISCOUNT_PCT = window.FDMinicartUpsellsConfig.upsellOtpDiscountPct;
    const STARTER_METAFIELD_KEYS = ['starter_multivitamin', 'starter_biotic', 'starter_magnesium'];
    const STARTER_METAFIELD_DATASET_KEYS = {
        starter_multivitamin: 'starterMultivitamin',
        starter_biotic: 'starterBiotic',
        starter_magnesium: 'starterMagnesium'
    };
    const starterMetafieldCache = new Map();

    function escapeHtmlAttr(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    // Upsell tab bucket. The Liquid pool supplies `category`; otherwise derive from the product title.
    // Order matters: 'teen'/'kid' are specific; women/men and everything else fall through to 'parents'.
    function getUpsellCategory(product) {
        if (product && product.category) return product.category;
        const title = String((product && product.title) || '').toLowerCase();
        if (title.includes('teen')) return 'teens';
        if (title.includes('kid')) return 'kids';
        return 'parents';
    }

    function getCartItemUpsellCategory(item) {
        if (!item) return 'parents';
        return getUpsellCategory({ title: item.product_title || item.title || '' });
    }

    // Free gift lines (bundle builder, quiz buy box, welcome kits, checkout GWP) never pick the tab.
    function isFreeGiftLine(item) {
        const props = (item && item.properties) || {};
        const truthy = v => v === true || v === 'true';
        return truthy(props._bundle_gift) ||
            truthy(props._free_gift) ||
            truthy(props._box_picker_gift) ||
            truthy(props._welcome_kit_gift) ||
            props._upsell_module === 'checkout_gwp';
    }

    function paidCartItems(cart) {
        const items = cart?.items || [];
        const paid = items.filter(item => !isFreeGiftLine(item));
        return paid.length ? paid : items;
    }

    function findLatestCartLineItem(cart, previousCart) {
        const items = paidCartItems(cart);
        if (!items.length) return null;
        if (items.length === 1) return items[0];

        const prevByKey = new Map((previousCart?.items || []).map(item => [item.key, item]));
        let latestItem = null;
        let latestScore = -1;

        items.forEach((item, index) => {
            const prev = prevByKey.get(item.key);
            let score = index;

            if (!prev) {
                score += 1000;
            } else if (item.quantity > prev.quantity) {
                score += 500;
            }

            if (score > latestScore) {
                latestScore = score;
                latestItem = item;
            }
        });

        return latestItem || items[items.length - 1];
    }

    function resolveActiveUpsellCategoryFromCart(cart, previousCart) {
        if (!cart?.items?.length) return getDefaultUpsellCategory();

        const paidItems = paidCartItems(cart);
        const uniqueProductIds = new Set(paidItems.map(item => item.product_id));
        if (uniqueProductIds.size === 1) {
            return getCartItemUpsellCategory(paidItems[0]);
        }

        return getCartItemUpsellCategory(findLatestCartLineItem(cart, previousCart));
    }

    function normalizeUpsellTabConfig() {
        const allowed = new Set(['kids', 'teens', 'parents']);
        const raw = String(window.__upsellTabConfig?.orderRaw || 'kids,teens,parents').split(',');
        const order = [];

        raw.forEach(slug => {
            const category = String(slug).trim().toLowerCase();
            if (!allowed.has(category) || order.includes(category)) return;
            order.push(category);
        });

        ['kids', 'teens', 'parents'].forEach(category => {
            if (!order.includes(category)) order.push(category);
        });

        return {
            order,
            defaultCategory: order[0] || 'kids',
        };
    }

    const UPSELL_TAB_CONFIG = normalizeUpsellTabConfig();
    const UPSELL_CATEGORY_ORDER = UPSELL_TAB_CONFIG.order;

    function getDefaultUpsellCategory() {
        return UPSELL_TAB_CONFIG.defaultCategory;
    }

    function resolveGlobalUpsellDiscountCode() {
        if (typeof bfcmCouponCode === 'string' && bfcmCouponCode.trim()) {
            return bfcmCouponCode.trim();
        }
        if (typeof MINICART_GLOBAL_COUPON_CODE === 'string' && MINICART_GLOBAL_COUPON_CODE.trim()) {
            return MINICART_GLOBAL_COUPON_CODE.trim();
        }
        return '';
    }

    function resolveActiveUpsellDiscount() {
        const offer = window.FDOffer && window.FDOffer.active;
        if (offer && offer.replacesGlobal) {
            return {
                otpPct: Number.isFinite(offer.otpPct) ? offer.otpPct : UPSELL_OTP_DISCOUNT_PCT,
                subPct: Number.isFinite(offer.subPct) ? offer.subPct : UPSELL_SUB_DISCOUNT_PCT,
                otpCode: String(offer.otpCode || offer.subCode || '').trim(),
                subCode: String(offer.subCode || offer.otpCode || '').trim(),
            };
        }

        const override = (typeof window !== 'undefined' && window.__pdpDiscountOverride) || null;
        if (override) {
            const otpPct = Number.isFinite(override.discountPercent)
                ? override.discountPercent
                : UPSELL_OTP_DISCOUNT_PCT;
            const subPct = Number.isFinite(override.subDiscountPercent)
                ? override.subDiscountPercent
                : otpPct;
            return {
                otpPct,
                subPct,
                otpCode: String(override.otpCouponCode || override.couponCode || resolveGlobalUpsellDiscountCode()).trim(),
                subCode: String(override.couponCode || override.otpCouponCode || resolveGlobalUpsellDiscountCode()).trim(),
            };
        }

        return {
            otpPct: UPSELL_OTP_DISCOUNT_PCT,
            subPct: UPSELL_SUB_DISCOUNT_PCT,
            otpCode: resolveGlobalUpsellDiscountCode(),
            subCode: resolveGlobalUpsellDiscountCode(),
        };
    }

    function applyGlobalUpsellDiscountProps(props) {
        const active = resolveActiveUpsellDiscount();
        if (active.otpCode) props._otp_discount_code = active.otpCode;
        if (active.subCode) props._sub_discount_code = active.subCode;
        if (!props._otp_discount_code && !props._sub_discount_code) return props;

        props._otp_discount_percentage = String(active.otpPct);
        props._sub_discount_percentage = String(active.subPct);
        props._discount_source = 'cart_upsells';
        return props;
    }

    function normalizeVariantId(value) {
        if (value == null || value === '') return null;

        if (typeof window.fromGID === 'function') {
            const gidValue = window.fromGID(value);
            if (gidValue) return String(gidValue);
        }

        const parsed = Number.parseInt(value, 10);
        if (!Number.isNaN(parsed) && parsed > 0) return String(parsed);

        return typeof value === 'string' ? value : null;
    }

    function normalizeProductCacheKey(productId) {
        if (productId == null || productId === '') return null;
        if (typeof productId === 'string') return productId;
        if (typeof productId === 'number' && !Number.isNaN(productId)) return String(productId);
        return null;
    }

    function sanitizeStarterMetafieldMap(map) {
        if (!map || typeof map !== 'object') return {};

        const result = {};
        STARTER_METAFIELD_KEYS.forEach(key => {
            const value = map[key];
            if (value != null && value !== '') result[key] = String(value);
        });

        return result;
    }

    function parseUpsellPercentProperty(value) {
        if (value === undefined || value === null || value === '') return null;

        const parsed = typeof value === 'number' ? value : parseFloat(value);
        if (!Number.isFinite(parsed) || parsed < 0 || parsed > 100) return null;

        return parsed;
    }

    function emptyUpsellDiscount() {
        return {
            hasOverride: false,
            otpCode: null,
            subCode: null,
            otpDiscountPercent: null,
            subDiscountPercent: null,
            source: null
        };
    }

    function normalizeDiscountCodeKey(value) {
        return String(value || '').trim().toUpperCase();
    }

    function getGlobalCouponKey() {
        const ctx = typeof window !== 'undefined' ? window.__pageCartContext : null;
        const fromCtx = ctx && ctx.globalCode;
        const fromTheme = typeof MINICART_GLOBAL_COUPON_CODE === 'string' ? MINICART_GLOBAL_COUPON_CODE : '';
        return normalizeDiscountCodeKey(fromCtx || fromTheme);
    }

    function isGlobalCouponCode(value) {
        const globalKey = getGlobalCouponKey();
        const key = normalizeDiscountCodeKey(value);
        return Boolean(globalKey && key && key === globalKey);
    }

    function isHiddenAutomaticDiscountTitle(value) {
        return normalizeDiscountCodeKey(value).indexOf('BULK ITEM VOLUME') !== -1;
    }

    function resolveUpsellOverrideFromCart(cart) {
        const emptyResult = emptyUpsellDiscount();
        if (!cart || !Array.isArray(cart.items)) return emptyResult;

        const overrideItem = cart.items.find(item => {
            const props = item && item.properties ? item.properties : {};
            return (
                (props._discount_source === 'pbfcm-product-carousel' ||
                    props._discount_source === 'cart_upsells') &&
                (
                    props._otp_discount_code ||
                    props._sub_discount_code ||
                    props._otp_discount_percentage ||
                    props._sub_discount_percentage
                )
            );
        });

        if (!overrideItem) return emptyResult;

        const props = overrideItem.properties || {};
        return {
            hasOverride: true,
            otpCode: props._otp_discount_code || null,
            subCode: props._sub_discount_code || null,
            otpDiscountPercent: parseUpsellPercentProperty(props._otp_discount_percentage),
            subDiscountPercent: parseUpsellPercentProperty(props._sub_discount_percentage),
            source: props._discount_source || null
        };
    }

    function resolvePdpUpsellDiscount() {
        const result = emptyUpsellDiscount();
        const override = (typeof window !== 'undefined' && window.__pdpDiscountOverride) || null;
        const profile = (typeof window !== 'undefined' && window.__pageCartContext && window.__pageCartContext.discountProfile) || null;

        if (override) {
            result.hasOverride = true;
            result.source = 'pdp_override';
            result.otpCode = override.otpCouponCode || override.couponCode || null;
            result.subCode = override.couponCode || null;
            result.otpDiscountPercent = parseUpsellPercentProperty(override.discountPercent);
            result.subDiscountPercent = parseUpsellPercentProperty(override.subDiscountPercent);
            if (result.subDiscountPercent == null) result.subDiscountPercent = result.otpDiscountPercent;
        }

        if (profile) {
            if (!result.otpCode && profile.otp_code) result.otpCode = String(profile.otp_code);
            if (!result.subCode && profile.sub_code) result.subCode = String(profile.sub_code);
            if (result.otpDiscountPercent == null) {
                result.otpDiscountPercent = parseUpsellPercentProperty(profile.otp_pct);
            }
            if (result.subDiscountPercent == null) {
                result.subDiscountPercent = parseUpsellPercentProperty(profile.sub_pct);
                if (result.subDiscountPercent == null) result.subDiscountPercent = result.otpDiscountPercent;
            }
            if (result.otpCode || result.subCode || result.otpDiscountPercent != null || result.subDiscountPercent != null) {
                result.hasOverride = true;
                if (!result.source) result.source = 'page_cart_context';
            }
        }

        return result;
    }

    function collectCartDiscountApplications(cart) {
        const apps = [];
        if (cart && Array.isArray(cart.cart_level_discount_applications)) {
            cart.cart_level_discount_applications.forEach(app => {
                if (app) apps.push(app);
            });
        }
        (cart && Array.isArray(cart.items) ? cart.items : []).forEach(item => {
            ((item && item.line_level_discount_allocations) || []).forEach(alloc => {
                if (alloc && alloc.discount_application) apps.push(alloc.discount_application);
            });
        });
        return apps;
    }

    function percentFromDiscountApplication(app) {
        if (!app) return null;
        if (String(app.value_type || '').toLowerCase() !== 'percentage') return null;
        if (isHiddenAutomaticDiscountTitle(app.title)) return null;
        return parseUpsellPercentProperty(app.value);
    }

    function collectPreferredOverrideCodes(cart, cartOverride, pageOverride) {
        const codes = [];
        const push = (value) => {
            const code = String(value || '').trim();
            if (code) codes.push(code);
        };

        if (cartOverride) {
            push(cartOverride.subCode);
            push(cartOverride.otpCode);
        }
        if (pageOverride) {
            push(pageOverride.subCode);
            push(pageOverride.otpCode);
        }
        (cart && Array.isArray(cart.items) ? cart.items : []).forEach(item => {
            if (isFreeGiftLine(item)) return;
            const props = (item && item.properties) || {};
            push(props._sub_discount_code);
            push(props._otp_discount_code);
        });
        (cart && Array.isArray(cart.discount_codes) ? cart.discount_codes : []).forEach(entry => {
            if (entry && entry.applicable === false) return;
            push(entry && entry.code);
        });

        return codes;
    }

    function inferPercentFromLineAllocations(cart, titleKey) {
        if (!titleKey) return null;
        const items = cart && Array.isArray(cart.items) ? cart.items : [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const original = Number(item && item.original_line_price);
            if (!original) continue;
            const allocations = (item && item.line_level_discount_allocations) || [];
            for (let a = 0; a < allocations.length; a++) {
                const alloc = allocations[a];
                const app = alloc && alloc.discount_application;
                if (!app || normalizeDiscountCodeKey(app.title) !== titleKey) continue;
                if (isHiddenAutomaticDiscountTitle(app.title)) continue;
                if (!Number.isFinite(alloc.amount) || alloc.amount <= 0) continue;
                return parseUpsellPercentProperty(Math.round((alloc.amount / original) * 100));
            }
        }
        return null;
    }

    function resolveAppliedOverridePercentFromCart(cart, preferredCodes) {
        const apps = collectCartDiscountApplications(cart);
        const scored = apps
            .map(app => ({ app, percent: percentFromDiscountApplication(app) }))
            .filter(entry => entry.percent != null);

        const preferred = new Set(
            (preferredCodes || []).map(normalizeDiscountCodeKey).filter(Boolean)
        );

        if (preferred.size) {
            const match = scored.find(({ app }) => preferred.has(normalizeDiscountCodeKey(app.title)));
            if (match && !isGlobalCouponCode(match.app.title)) {
                return { percent: match.percent, code: match.app.title || null };
            }

            const preferredTitles = Array.from(preferred).filter(key => key && !isGlobalCouponCode(key));
            for (let i = 0; i < preferredTitles.length; i++) {
                const inferred = inferPercentFromLineAllocations(cart, preferredTitles[i]);
                if (inferred != null) {
                    const app = apps.find(candidate => normalizeDiscountCodeKey(candidate.title) === preferredTitles[i]);
                    return { percent: inferred, code: (app && app.title) || preferredTitles[i] };
                }
            }
        }

        const overrideApp = scored.find(({ app }) => {
            if (String(app.type || '').toLowerCase() === 'automatic') return false;
            const title = app.title || '';
            return title && !isGlobalCouponCode(title);
        });
        if (overrideApp) {
            return { percent: overrideApp.percent, code: overrideApp.app.title || null };
        }

        return { percent: null, code: null };
    }

    // Preview + ATC share this so a replacing cart/page code (BUNDLEBUILDER 30%)
    // wins over the theme Global Pricing rates (40% sub / 30% OTP).
    function resolveEffectiveUpsellDiscount(cart) {
        const cartOverride = resolveUpsellOverrideFromCart(cart);
        const pageOverride = resolvePdpUpsellDiscount();
        const preferredCodes = collectPreferredOverrideCodes(cart, cartOverride, pageOverride);
        const applied = resolveAppliedOverridePercentFromCart(cart, preferredCodes);

        const otpCode = pageOverride.otpCode || applied.code || cartOverride.otpCode || null;
        const subCode = pageOverride.subCode || applied.code || cartOverride.subCode || null;

        // Explicit page percents win. Then the live cart application (BUNDLEBUILDER
        // 30%), so a leftover cart_upsells stamp of the global 40% cannot leak.
        let otpPct = pageOverride.otpDiscountPercent;
        let subPct = pageOverride.subDiscountPercent;

        if (applied.percent != null) {
            if (otpPct == null) otpPct = applied.percent;
            if (subPct == null) subPct = applied.percent;
        }

        if (otpPct == null && cartOverride.otpDiscountPercent != null) otpPct = cartOverride.otpDiscountPercent;
        if (subPct == null && cartOverride.subDiscountPercent != null) subPct = cartOverride.subDiscountPercent;

        const session = resolveActiveUpsellDiscount();
        if (otpPct == null && Number.isFinite(session.otpPct)) otpPct = session.otpPct;
        if (subPct == null && Number.isFinite(session.subPct)) subPct = session.subPct;

        if (otpPct == null) otpPct = UPSELL_OTP_DISCOUNT_PCT;
        if (subPct == null) subPct = UPSELL_SUB_DISCOUNT_PCT;

        return {
            hasOverride: Boolean(
                cartOverride.hasOverride ||
                pageOverride.hasOverride ||
                applied.percent != null
            ),
            otpCode,
            subCode,
            otpDiscountPercent: otpPct,
            subDiscountPercent: subPct,
            source: cartOverride.source || pageOverride.source || (applied.percent != null ? 'cart_application' : null)
        };
    }

    async function resolveUpsellOverrideFromCurrentCart() {
        try {
            const cartResponse = await fetch('/cart.js', { credentials: 'same-origin' });
            if (!cartResponse.ok) throw new Error(`Cart fetch failed with status ${cartResponse.status}`);

            const cart = await cartResponse.json();
            return resolveEffectiveUpsellDiscount(cart);
        } catch (error) {
            console.warn('[UPSELLS] Failed resolving override discount from cart', error);
            return emptyUpsellDiscount();
        }
    }

    async function fetchStarterMetafieldsForProductId(productId) {
        const cacheKey = normalizeProductCacheKey(productId);

        if (!cacheKey) {
            console.log('[fetchStarterMetafieldsForProductId] No cache key, returning empty object');
            return {};
        }

        if (starterMetafieldCache.has(cacheKey)) return starterMetafieldCache.get(cacheKey);

        const fetcher = window.Storefront && window.Storefront.productStarterMetafieldsById;

        if (typeof fetcher !== 'function') {
            starterMetafieldCache.set(cacheKey, {});
            return {};
        }

        try {
            const metafields = await fetcher(productId);
            const sanitized = sanitizeStarterMetafieldMap(metafields);
            starterMetafieldCache.set(cacheKey, sanitized);
            return sanitized;
        } catch (error) {
            console.warn('Mini cart: failed to fetch starter metafields for product', productId, error);
            starterMetafieldCache.set(cacheKey, {});
            return {};
        }
    }

    async function getProductByHandle(handle) {
        const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        if (!res.ok) throw new Error(`Failed to fetch product ${handle}`);
        return res.json();
    }

    function planNameLooksNinety(name) {
        return /90|quarter|3 month|every 3|12 week/.test(String(name || '').toLowerCase());
    }

    function pickNonNinetyDaySellingPlanId(product, variantId) {
        if (!product || !variantId) return null;
        const variant = (product.variants || []).find(v => String(v.id) === String(variantId));
        const allocations = (variant && Array.isArray(variant.selling_plan_allocations))
            ? variant.selling_plan_allocations
            : [];
        const planById = {};
        (product.selling_plan_groups || []).forEach(group => {
            (group.selling_plans || []).forEach(plan => {
                if (plan && plan.id != null) planById[String(plan.id)] = plan;
            });
        });
        let thirty = null;
        let other = null;
        allocations.forEach(allocation => {
            const id = allocation && allocation.selling_plan_id ? String(allocation.selling_plan_id) : '';
            if (!id) return;
            const plan = planById[id] || {};
            if (planNameLooksNinety(plan.name)) return;
            const name = String(plan.name || '').toLowerCase();
            if (/30|1 month|month|4 week/.test(name) && !thirty) thirty = id;
            else if (!other) other = id;
        });
        return thirty || other;
    }

    // Prefer a 30-day plan this variant actually supports. Never first-allocation
    // 90-day — that is what 90-option LPs expose as allocations[0].
    async function getProductSellingPlanIdForVariant(handle, variantId) {
        if (!handle || !variantId) return null;
        try {
            const product = await getProductByHandle(handle);
            return pickNonNinetyDaySellingPlanId(product, variantId);
        } catch (error) {
            console.warn('Mini cart: failed to resolve product-specific selling plan', error);
            return null;
        }
    }

    async function getUpsellProducts(cartItem) {
        try {
            let upsellProductIds = await window.Storefront.productSidecartUpsellsById(cartItem.product_id);

            if (!upsellProductIds || !upsellProductIds?.length || !Array.isArray(upsellProductIds)) {
                return [];
            }

            upsellProductIds = upsellProductIds
                .map(doc => window.fromGID(doc.id))
                .filter(Boolean);

            const upsellProducts = await makeStorefrontQuery.productsByIds(upsellProductIds);

            const enrichedProducts = await Promise.all((upsellProducts || []).map(async product => {
                if (!product) return product;

                const hasMetafields = product.starter_metafields && Object.keys(product.starter_metafields).length > 0;
                if (hasMetafields || !product.id) return product;

                const starterMetafields = await fetchStarterMetafieldsForProductId(product.id);
                return {
                    ...product,
                    starter_metafields: starterMetafields
                };
            }));

            return enrichedProducts;
        } catch (error) {
            console.error('Error fetching upsell products:', error);
            return [];
        }
    }

    let emptyCartUpsellProductsPromise = null;

    function getEmptyCartUpsellProducts() {
        if (!emptyCartUpsellProductsPromise) {
            emptyCartUpsellProductsPromise = loadEmptyCartUpsellProducts().then(products => {
                if (!products.length) emptyCartUpsellProductsPromise = null;
                return products;
            });
        }
        return emptyCartUpsellProductsPromise;
    }

    async function loadEmptyCartUpsellProducts() {
        if (!Array.isArray(EMPTY_CART_UPSELL_HANDLES) || EMPTY_CART_UPSELL_HANDLES.length === 0) {
            return [];
        }

        const uniqueHandles = Array.from(new Set(
            EMPTY_CART_UPSELL_HANDLES
                .map(handle => typeof handle === 'string' ? handle.trim() : '')
                .filter(Boolean)
        ));

        if (uniqueHandles.length === 0) return [];

        let fallbackProducts = await Promise.all(uniqueHandles.map(async handle => {
            try {
                const printed = EMPTY_CART_UPSELL_PRODUCTS[handle];
                const product = printed && printed.id ? printed : await getProductByHandle(handle);
                if (!product) return null;

                const starterMetafields = await fetchStarterMetafieldsForProductId(product.id);

                return {
                    ...product,
                    starter_metafields: starterMetafields
                };
            } catch (error) {
                console.warn('Mini cart: failed to load fallback upsell product', handle, error);
                return null;
            }
        }));

        fallbackProducts = fallbackProducts
            .filter(Boolean)
            .map(product => ({
                ...product,
                price: product.price / 100,
                price_max: product.price_max / 100,
                price_min: product.price_min / 100
            }));

        return fallbackProducts.filter(product => Boolean(product));
    }

    function getEmptyCartUpsellVisibleLimit() {
        const max = parseInt(EMPTY_CART_UPSELL_MAX_COUNT, 10);
        return Math.max(1, Number.isNaN(max) ? 4 : max);
    }

    async function populateEmptyCartStarterPacks(cart) {
        const container = document.getElementById('mini_cart_empty_starter_packs');
        const section = document.getElementById('mini_cart_empty_starter_packs_wrap');
        if (!container) return;

        const cartIsEmpty = !cart || !Array.isArray(cart.items) || cart.items.length === 0;
        if (!cartIsEmpty) {
            if (container.firstChild) container.innerHTML = '';
            if (section && !section.hidden) section.hidden = true;
            return;
        }

        const products = (await getEmptyCartUpsellProducts()).slice(0, getEmptyCartUpsellVisibleLimit());
        if (!products.length) {
            container.innerHTML = '';
            if (section) section.hidden = true;
            return;
        }

        const cards = (await Promise.all(products.map(product => renderRecommendationCard(product, cart)))).filter(Boolean);

        container.innerHTML = cards.join('');
        if (section) section.hidden = cards.length === 0;
    }

    // Graceful fallback for when no configured upsells resolve — e.g. a cart
    // item's product isn't visible to the Storefront API token, so its
    // sidecart-upsell lookup (productSidecartUpsellsById) returns []. Uses
    // Shopify's native /recommendations endpoint (Online Store context, NO
    // Storefront token) so the widget degrades to related products instead of
    // disappearing. reviews/blurb/starter_metafields are pre-filled so
    // renderRecommendationCard makes no per-card Storefront calls either.
    async function getFallbackRecommendations(cart) {
        if (!cart || !Array.isArray(cart.items) || !cart.items.length) return [];

        const inCart = new Set(cart.items.map(item => item.product_id));
        const seen = new Set();
        const collected = [];

        const responses = await Promise.all(cart.items.map(async item => {
            try {
                const res = await fetch(
                    `/recommendations/products.json?product_id=${encodeURIComponent(item.product_id)}&limit=6&intent=related`,
                    { credentials: 'same-origin' }
                );
                if (!res.ok) return [];
                const json = await res.json();
                return json.products || [];
            } catch (error) {
                console.warn('[UPSELLS] fallback recommendations failed for', item.product_id, error);
                return [];
            }
        }));

        responses.forEach(products => {
            products.forEach(p => {
                if (!p || inCart.has(p.id) || seen.has(p.id)) return;
                seen.add(p.id);
                collected.push({
                    id: p.id,
                    handle: p.handle,
                    title: p.title,
                    // /recommendations returns prices in cents; renderRecommendationCard
                    // expects dollars (it re-multiplies via toCents).
                    price: typeof p.price === 'number' ? p.price / 100 : p.price,
                    compare_at_price: p.compare_at_price ? p.compare_at_price / 100 : null,
                    featured_image: p.featured_image || (Array.isArray(p.images) ? p.images[0] : null) || null,
                    variants: Array.isArray(p.variants) ? p.variants : [],
                    // Pre-filled to skip Storefront enrichment fetches.
                    reviews: '',
                    blurb: '',
                    starter_metafields: {}
                });
            });
        });

        return collected;
    }

    async function populateRecommendations(cart, previousCart) {
        const recommendationsContainer = document.getElementById('mini_cart_upsell');
        if (!recommendationsContainer) return;

        let productsToRender = [];

        const isAbDrawer = Boolean(document.querySelector('.ab-cart-drawer .firstday-cart__flyout-recommendations'));
        const abPool = Array.isArray(window.__abUpsellPool) ? window.__abUpsellPool : [];
        const cartMatchers = getCartUpsellMatchers(cart);
        const upsellLimit = getUpsellVisibleLimit();
        if (isAbDrawer && abPool.length) {
            // A/B drawer: when a visible-count limit is on, keep the full pool in the DOM and
            // let applyUpsellCategoryFilter hide in-cart + overflow slots so the next card
            // promotes when one is added. Without a limit, drop in-cart products at render time.
            productsToRender = upsellLimit !== null
                ? abPool.slice()
                : abPool.filter(product => !isUpsellProductInCart(product, cartMatchers));
        } else if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
            productsToRender = [];
        } else {
            const alreadyInCart = new Set();
            cart.items.forEach(item => alreadyInCart.add(item.product_id));

            const recommendationsToShow = new Set();
            const recommendationLists = await Promise.all(cart.items.map(item => getUpsellProducts(item)));

            recommendationLists.forEach(recommendations => {
                recommendations.forEach(recommendationProduct => {
                    if (!alreadyInCart.has(recommendationProduct.id)) {
                        recommendationsToShow.add(recommendationProduct);
                        alreadyInCart.add(recommendationProduct.id);
                    }
                });
            });

            productsToRender = Array.from(recommendationsToShow);
        }

        // Graceful degradation: if nothing resolved (e.g. a cart item's product
        // isn't visible to the Storefront API token, so its sidecart-upsell
        // lookup returns []), fall back to native related-product recommendations
        // so the whole widget never disappears.
        if (!productsToRender.length && cart && Array.isArray(cart.items) && cart.items.length) {
            productsToRender = await getFallbackRecommendations(cart);
        }

        const recommendationCards = (await Promise.all(
            productsToRender.map(product => renderRecommendationCard(product, cart))
        )).filter(Boolean);

        const recommendationsSection = document.querySelector('.firstday-cart__flyout-recommendations');

        if (recommendationCards.length > 0) {
            const recommendationsHtml = recommendationCards.join('');
            if (
                recommendationsHtml === lastRecommendationsHtml &&
                recommendationsContainer === lastRecommendationsContainer &&
                recommendationsContainer.children.length === recommendationCards.length
            ) {
                resetChangedRecommendationCards(recommendationsContainer, recommendationCards);
            } else {
                recommendationsContainer.innerHTML = recommendationsHtml;
                lastRecommendationsHtml = recommendationsHtml;
                lastRecommendationsContainer = recommendationsContainer;
            }
            if (recommendationsSection) recommendationsSection.style.display = 'flex';
            if (isAbDrawer && !preserveActiveUpsellCategory) {
                activeUpsellCategory = resolveActiveUpsellCategoryFromCart(cart, previousCart);
            }
            preserveActiveUpsellCategory = false;
            applyUpsellCategoryFilter();
            if (!isAbDrawer) applyControlUpsellVisibleLimit();
            if (window.FDCartContext && typeof window.FDCartContext.warmPreorderTextIn === 'function') {
                window.FDCartContext.warmPreorderTextIn(recommendationsContainer);
            }
        } else {
            recommendationsContainer.innerHTML = '';
            lastRecommendationsHtml = '';
            lastRecommendationsContainer = null;
            if (recommendationsSection) recommendationsSection.style.display = 'none';
        }
    }

    let lastRecommendationsHtml = '';
    let lastRecommendationsContainer = null;

    function isRecommendationCardChanged(card) {
        const unchecked = Array.from(card.querySelectorAll('.upsell-subscribe-checkbox')).some(box => !box.checked);
        if (unchecked) return true;
        return Array.from(card.querySelectorAll('.quantity-input')).some(input =>
            input.value !== '1' || input.getAttribute('value') !== '1'
        );
    }

    function resetChangedRecommendationCards(container, cardsHtml) {
        Array.from(container.children).forEach((card, index) => {
            if (!isRecommendationCardChanged(card)) return;
            const template = document.createElement('template');
            template.innerHTML = cardsHtml[index];
            const fresh = template.content.firstElementChild;
            if (fresh) card.replaceWith(fresh);
        });
    }

    // A/B cart drawer only: filter rendered upsell cards by the active category tab and
    // surface the "all added" message when the active tab has no cards. No-op in the control
    // drawer, where the flat list stays untouched.
    let activeUpsellCategory = UPSELL_TAB_CONFIG.defaultCategory;
    let preserveActiveUpsellCategory = false;

    function getUpsellVisibleLimit() {
        const config = window.__miniCartUpsellLimit;
        if (!config || !config.enabled) return null;
        const max = parseInt(config.max, 10);
        return Math.max(1, Number.isNaN(max) ? 3 : max);
    }

    function getCartUpsellMatchers(cart) {
        const ids = new Set();
        const handles = new Set();

        if (!cart || !Array.isArray(cart.items)) return { ids, handles };

        cart.items.forEach(item => {
            const productId = Number(item.product_id);
            if (!Number.isNaN(productId)) ids.add(productId);
            if (item.handle) handles.add(String(item.handle).toLowerCase());

            const props = item.properties || {};
            if (props._bundle) {
                const parentId = Number(props._parent_pdp);
                if (parentId) ids.add(parentId);
                if (props._parent_pdp_handle) handles.add(String(props._parent_pdp_handle).toLowerCase());
            }
        });

        return { ids, handles };
    }

    function isUpsellProductInCart(product, matchers) {
        if (!product || !matchers) return false;

        const productId = Number(product.id);
        if (!Number.isNaN(productId) && matchers.ids.has(productId)) return true;

        if (product.handle && matchers.handles.has(String(product.handle).toLowerCase())) return true;

        return false;
    }

    function isUpsellCardInCart(card, cart) {
        if (!card) return false;

        const matchers = getCartUpsellMatchers(cart);
        const productId = Number(card.dataset.productId);
        if (!Number.isNaN(productId) && matchers.ids.has(productId)) return true;

        const handle = card.dataset.productHandle;
        if (handle && matchers.handles.has(String(handle).toLowerCase())) return true;

        return false;
    }

    function isUpsellCardEligible(card, category, cart) {
        return card.dataset.category === category && !isUpsellCardInCart(card, cart);
    }

    function applyControlUpsellVisibleLimit() {
        const limit = getUpsellVisibleLimit();
        if (limit === null) return;

        const container = document.getElementById('mini_cart_upsell');
        if (!container || container.closest('.ab-cart-drawer')) return;

        const cart = typeof latestCartState !== 'undefined' ? latestCartState : null;
        const cards = Array.from(container.querySelectorAll(':scope > .firstday-cart__flyout-item'));
        let shown = 0;

        cards.forEach(card => {
            let show = !isUpsellCardInCart(card, cart);

            if (show) {
                shown += 1;
                if (shown > limit) show = false;
            }

            card.style.display = show ? '' : 'none';
        });
    }

    function applyUpsellCategoryFilter() {
        const recs = document.querySelector('.ab-cart-drawer .firstday-cart__flyout-recommendations');
        if (!recs) return;

        const cards = Array.from(recs.querySelectorAll('#mini_cart_upsell > .firstday-cart__flyout-item'));
        if (!cards.length) return;

        const cart = typeof latestCartState !== 'undefined' ? latestCartState : null;

        if (!cards.some(card => isUpsellCardEligible(card, activeUpsellCategory, cart))) {
            const fallbackCategory = UPSELL_CATEGORY_ORDER.find(category =>
                cards.some(card => isUpsellCardEligible(card, category, cart))
            );
            if (fallbackCategory) activeUpsellCategory = fallbackCategory;
        }

        const limit = getUpsellVisibleLimit();
        let visible = 0;
        let shownInCategory = 0;

        cards.forEach(card => {
            const match = card.dataset.category === activeUpsellCategory;
            let show = match && !isUpsellCardInCart(card, cart);

            if (show && limit !== null) {
                shownInCategory += 1;
                if (shownInCategory > limit) show = false;
            }

            card.style.display = show ? '' : 'none';
            if (show) visible += 1;
        });

        recs.querySelectorAll('.firstday-cart__flyout-recommendations__tabs .fd-tabs-v3__item').forEach(btn => {
            const on = btn.dataset.upsellCategory === activeUpsellCategory;
            btn.classList.toggle('fd-tabs-v3__item--active', on);
            btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        const empty = recs.querySelector('.firstday-cart__flyout-recommendations__empty');
        if (empty) empty.hidden = visible > 0;
    }

    const toCents = (value) => {
        const num = parseFloat(value);
        if (isNaN(num)) throw new Error("Invalid number");
        return Math.round(num * 100).toString();
    };

    async function renderRecommendationCard(product, cart) {
        try {
            const productImage = product.featured_image
                ? (product.featured_image.includes('width=') ? product.featured_image : `${product.featured_image}&width=180`)
                : '';
            const price = toCents(product.price || 0);
            const compareAtPrice = toCents(product.compare_at_price || 0);
            const basePriceCents = Number.parseInt(price, 10);
            const subscribeCheckboxId = `upsell-subscribe-${product.id}`;
            const isAddOnProduct = product.handle && product.handle.includes('add-on');

            // Same resolver as ATC: page/cart override or the applied code rate
            // (BUNDLEBUILDER 30%) wins over theme Global Pricing (40% / 30%).
            const sourceCart = (cart && Array.isArray(cart.items))
                ? cart
                : (typeof latestCartState !== 'undefined' && latestCartState && Array.isArray(latestCartState.items))
                    ? latestCartState
                    : null;
            const upsellOverride = sourceCart
                ? resolveEffectiveUpsellDiscount(sourceCart)
                : await resolveUpsellOverrideFromCurrentCart();

            const sessionDiscount = resolveActiveUpsellDiscount();
            const effectiveSubPct = Number.isFinite(upsellOverride.subDiscountPercent)
                ? upsellOverride.subDiscountPercent
                : sessionDiscount.subPct;
            const effectiveOtpPct = Number.isFinite(upsellOverride.otpDiscountPercent)
                ? upsellOverride.otpDiscountPercent
                : sessionDiscount.otpPct;
            const effectiveCouponCode =
                upsellOverride.subCode ||
                upsellOverride.otpCode ||
                sessionDiscount.subCode ||
                sessionDiscount.otpCode ||
                bfcmCouponCode;

            // Session overlay (funnel latch) wins over theme 40/30. Cart-line
            // stamps still win when an item is already in the drawer.
            const otpDiscountMultiplier = (100 - effectiveOtpPct) / 100;
            const subDiscountMultiplier = (100 - effectiveSubPct) / 100;

            const oneTimePriceCents = Number.isNaN(basePriceCents)
                ? null
                : Math.round(basePriceCents * otpDiscountMultiplier);
            const subscriptionPriceCents = Number.isNaN(basePriceCents)
                ? null
                : Math.round(basePriceCents * subDiscountMultiplier);

            const shouldShowCouponMessage =
                Boolean(isBFCMPage || upsellOverride.hasOverride || effectiveCouponCode);

            // "Extra" subscriber saving vs one-time, derived from the two rates
            // (e.g. 40% sub − 30% one-time → "an EXTRA 10%").
            const subPctDisplay = Math.round((1 - subDiscountMultiplier) * 100);
            const otpPctDisplay = Math.round((1 - otpDiscountMultiplier) * 100);
            const extraSubPct = Math.max(0, subPctDisplay - otpPctDisplay);
            const subscribeLabelText = extraSubPct > 0
                ? `Subscribe &amp; Save an EXTRA ${extraSubPct}%`
                : 'Subscribe &amp; Save';

            const convertValueToCents = (value) => {
                if (value === undefined || value === null || value === '') return null;
                const normalized = String(value).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
                if (!normalized) return null;
                const floatValue = parseFloat(normalized);
                if (Number.isNaN(floatValue)) return null;
                return Math.round(floatValue * 100);
            };

            let addOnPromoCents = null;
            let addOnFullCents = null;

            if (isAddOnProduct) {
                if (product.addon_promo !== undefined || product.addon_full !== undefined) {
                    // Pre-supplied by the Liquid pool — no fetch.
                    addOnPromoCents = convertValueToCents(product.addon_promo);
                    addOnFullCents = convertValueToCents(product.addon_full);
                } else if (window.Storefront && typeof window.Storefront.productAddOnPricingById === 'function') {
                    try {
                        const addOnPricing = await window.Storefront.productAddOnPricingById(product.id);
                        addOnPromoCents = convertValueToCents(addOnPricing?.promo);
                        addOnFullCents = convertValueToCents(addOnPricing?.full);
                    } catch (error) {
                        console.error('Mini cart: failed to fetch add-on pricing for recommendations', error);
                    }
                }
            }

            const showAddOnPricing = isAddOnProduct && addOnPromoCents != null && addOnFullCents != null;

            // Presence (not length) is enough: pool/contextual products already carry starter_metafields
            // (possibly {}), so an empty object means "none" rather than "not loaded" — avoids a refetch.
            const starterMetafields = (product && product.starter_metafields)
                ? product.starter_metafields
                : await fetchStarterMetafieldsForProductId(product?.id);

            if (product && starterMetafields && !product.starter_metafields) {
                product.starter_metafields = starterMetafields;
            }

            const baseDataAttributes = [];

            if (product?.id) baseDataAttributes.push(`data-product-id="${escapeHtmlAttr(product.id)}"`);
            if (product?.handle) baseDataAttributes.push(`data-product-handle="${escapeHtmlAttr(product.handle)}"`);
            if (product?.title) baseDataAttributes.push(`data-product-title="${escapeHtmlAttr(product.title)}"`);

            STARTER_METAFIELD_KEYS.forEach(key => {
                const value = starterMetafields && starterMetafields[key];
                if (value) {
                    const attributeName = `data-${key.replace(/_/g, '-')}`;
                    baseDataAttributes.push(`${attributeName}="${escapeHtmlAttr(value)}"`);
                }
            });

            const buttonDataAttributesList = baseDataAttributes.slice();

            if (showAddOnPricing) {
                buttonDataAttributesList.push(`data-addon-promo-price="${addOnPromoCents}"`);
                buttonDataAttributesList.push(`data-addon-full-price="${addOnFullCents}"`);
            }

            const buttonDataAttributes = buttonDataAttributesList.length ? ` ${buttonDataAttributesList.join(' ')}` : '';
            const upsellVariantId = product?.variants?.[0]?.id || '';
            const upsellSaleMultiplier = showAddOnPricing
                ? (addOnFullCents > 0 ? addOnPromoCents / addOnFullCents : null)
                : subDiscountMultiplier;
            const upsellVariantAttr = upsellVariantId ? ` data-variant-id="${upsellVariantId}"` : '';
            const upsellMultiplierAttr = upsellSaleMultiplier != null && upsellSaleMultiplier < 1
                ? ` data-price-multiplier="${upsellSaleMultiplier}"`
                : '';

            let priceMarkup;
            const showAddOnCompare = showAddOnPricing && addOnFullCents > addOnPromoCents;
            const showSubCompare = !showAddOnPricing && subscriptionPriceCents != null && Number(price) > subscriptionPriceCents;

            if (showAddOnPricing) {
                priceMarkup = `
                    <div class="firstday-cart__flyout-item-price is-bfcm">
                    <div>
                        ${showAddOnCompare ? `<span class="firstday-money base-price compare-at igPrice"${upsellVariantAttr}>${Shopify.formatMoney(addOnFullCents, '$--amount--')}</span>` : ''}
                        <span class="firstday-money subscription-price igPrice" id="label-subscription-price8"${upsellVariantAttr}${upsellMultiplierAttr}>${Shopify.formatMoney(addOnPromoCents, '$--amount--')}</span>
</div>
${shouldShowCouponMessage ? `<div class="bfcm-coupon-message">with <strong>${effectiveCouponCode}</strong> code applied</div>` : ''}

                    </div>
                `;
            } else {
                priceMarkup = `
                    <div class="firstday-cart__flyout-item-price is-bfcm">
                    <div>
                        ${showSubCompare ? `<span class="firstday-money base-price compare-at igPrice"${upsellVariantAttr}>${Shopify.formatMoney(price, '$--amount--')}</span>` : ''}
                        ${subscriptionPriceCents != null ? `<span class="firstday-money subscription-price igPrice" id="label-subscription-price9"${upsellVariantAttr}${upsellMultiplierAttr}>${Shopify.formatMoney(subscriptionPriceCents, '$--amount--')}</span>` : ''}
                        ${oneTimePriceCents != null ? `<span class="firstday-money onetime-price igPrice" style="display:none;"${upsellVariantAttr} data-price-multiplier="${otpDiscountMultiplier}">${Shopify.formatMoney(oneTimePriceCents, '$--amount--')}</span>` : ''}
                    </div>

${shouldShowCouponMessage ? `<div class="bfcm-coupon-message">with <strong>${effectiveCouponCode}</strong> code applied</div>` : ''}

                    </div>
                `;
            }

            const [reviewsHTML, blurbHTML] = await Promise.all([
                product.reviews !== undefined ? product.reviews : window.Storefront.productReviewsById(product.id),
                product.blurb !== undefined ? product.blurb : window.Storefront.productBlurbById(product.id)
            ]);
            
            let reviewsAriaLabel = 'Product rating';

            if (reviewsHTML) {
                const ratingMatch = reviewsHTML.match(/data-average-rating="([\d.]+)"|(\d+\.?\d*)\s*(?:out of|\/)\s*5|rating['":\s]+(\d+\.?\d*)/i);
                if (ratingMatch) {
                    const ratingValue = ratingMatch[1] || ratingMatch[2] || ratingMatch[3];
                    reviewsAriaLabel = `Product rating: ${ratingValue} out of 5 stars`;
                }
            }
            
            const productTitleAttr = escapeHtmlAttr(product.title || '');
            const cardId = `recommendation-card-${product.id}`;
            const titleId = `rec-title-${product.id}`;
            const quantityInputId = `upsell-quantity-${product.id}`;
            const detailsQuantityInputId = `upsell-quantity-${product.id}-details`;
            const subscribeBenefitId = `subscribe-benefit-${product.id}`;
            const detailsPriceMarkup = priceMarkup.replace(/\s+id="[^"]*"/g, '');

            const renderPriceAndControls = (inputId, extraClass, currentPriceMarkup) => `
                <div class="mini-cart-product-price-and-controls ${extraClass}">
                    <div class="firstday-cart__flyout-item-quantity"
                         role="group"
                         aria-label="Quantity for ${productTitleAttr}">
                        <button type="button" 
                                class="quantity-btn minus" 
                                aria-label="Decrease quantity"
                                onclick="changeRecommendationQuantity(this, -1)">
                            <span aria-hidden="true">${UI_ICONS.minus}</span>
                        </button>
                        <label for="${inputId}" class="visually-hidden">
                            Quantity to add
                        </label>
                        <input type="number" 
                               value="1" 
                               min="1" 
                               class="quantity-input"
                               id="${inputId}"
                               onchange="sanitizeRecommendationQuantity(this)">
                        <button type="button" 
                                class="quantity-btn plus" 
                                aria-label="Increase quantity"
                                onclick="changeRecommendationQuantity(this, 1)">
                            <span aria-hidden="true">${UI_ICONS.plus}</span>
                        </button>
                    </div>
                    ${currentPriceMarkup}

                </div>
            `;

            return `
        <article class="firstday-cart__flyout-item product-${product.handle}"
                 data-product-id="${product.id}"
                 data-product-handle="${escapeHtmlAttr(product.handle)}"
                 data-category="${getUpsellCategory(product)}"
                 id="${cardId}"
                 aria-labelledby="${titleId}">
            <div class="mini-cart-product-container">
                <div class="mini-cart-product-content">
                    <div class="firstday-cart__flyout-item-media">
                        <a href="/products/${product.handle}" 
                           aria-label="View ${productTitleAttr} product page">
                            <img src="${productImage}" 
                                 alt="Product image: ${productTitleAttr}" 
                                 loading="lazy">
                        </a>
                    </div>
                    <div class="firstday-cart__flyout-item-details">
                        <div class="mini-cart-product-title-row">
                            <a href="/products/${product.handle}" 
                               class="firstday-cart__flyout-item-product-title"
                               id="${titleId}">
                                ${product.title}
                            </a>
                        </div>
                        ${blurbHTML ? `<div class="product-blurb">${blurbHTML}</div>` : ''}
                        ${reviewsHTML ? `<div class='jdgm-widget jdgm-preview-badge' role="img" aria-label="${reviewsAriaLabel}">${reviewsHTML}</div>` : ''}
                        ${renderPriceAndControls(detailsQuantityInputId, 'ab-cart-drawer__details-price-and-controls', detailsPriceMarkup)}
                    </div>
                </div>

                ${renderPriceAndControls(quantityInputId, 'ab-cart-drawer__base-price-and-controls', priceMarkup)}
                <div class="mini-cart-product-footer">
<div class="upsell-subscribe-container">
                    <div class="upsell-subscribe-option">
                        <input type="checkbox" 
                               id="${subscribeCheckboxId}" 
                               class="upsell-subscribe-checkbox" 
                               checked
                               aria-describedby="${subscribeBenefitId}">
                        <label for="${subscribeCheckboxId}">
                            ${subscribeLabelText}
                        </label>
                        <span id="${subscribeBenefitId}" class="visually-hidden">
                            Check this box to subscribe and save 15% on recurring deliveries
                        </span>
                    </div>
</div>

                    <button type="button"
                            class="firstday-button firstday-cart__checkout-button block new-mini-cart-checkout-button firstday_secundary_minicart_button"
                            ${buttonDataAttributes}
                            aria-label="Add ${productTitleAttr} to cart"
                            onclick="addRecommendationToCart('${product.variants?.[0]?.id}', this)">
                        Add to Cart
                    </button>
                </div>
            </div>
        </article>
        `;
        } catch (error) {
            console.error('Error rendering recommendation card:', error);
            return '';
        }
    }

    function sanitizeRecommendationQuantity(input) {
        if (!input) return;

        const min = parseInt(input.getAttribute('min'), 10) || 1;
        const value = parseInt(input.value, 10);
        const safeValue = Number.isNaN(value) || value < min ? min : value;

        input.value = safeValue;
        input.setAttribute('value', String(safeValue));
    }

    function syncRecommendationQuantityInputs(upsellItem, nextValue) {
        if (!upsellItem) return;

        const min = 1;
        const safeValue = Math.max(min, nextValue);

        upsellItem.querySelectorAll('.quantity-input').forEach(input => {
            input.value = safeValue;
            input.setAttribute('value', String(safeValue));
        });
    }

    function changeRecommendationQuantity(button, delta) {
        if (!button) return;

        const quantityWrapper = button.closest('.firstday-cart__flyout-item-quantity');
        if (!quantityWrapper) return;

        const input = quantityWrapper.querySelector('.quantity-input');
        if (!input) return;

        const min = parseInt(input.getAttribute('min'), 10) || 1;
        const currentValue = parseInt(input.value, 10);
        const safeCurrentValue = Number.isNaN(currentValue) ? min : currentValue;
        const nextValue = Math.max(min, safeCurrentValue + delta);
        const upsellItem = button.closest('.firstday-cart__flyout-item');

        if (upsellItem) {
            syncRecommendationQuantityInputs(upsellItem, nextValue);
        } else {
            input.value = nextValue;
            input.setAttribute('value', String(nextValue));
        }

        sanitizeRecommendationQuantity(input);
    }

    function updateUpsellPriceDisplay(upsellItem, isSubscribed) {
        if (!upsellItem) return;

        const priceWrappers = upsellItem.querySelectorAll('.firstday-cart__flyout-item-price');
        if (!priceWrappers.length) return;

        priceWrappers.forEach(priceWrapper => {
            const basePriceEl = priceWrapper.querySelector('.firstday-money.base-price');
            const subscriptionPriceEl = priceWrapper.querySelector('.firstday-money.subscription-price');
            const oneTimePriceEl = priceWrapper.querySelector('.firstday-money.onetime-price');

            if (oneTimePriceEl) {
                // Non-stacked model: both states are discounted, so the full price is
                // always struck through; toggle which discounted price is shown.
                if (basePriceEl) basePriceEl.classList.add('compare-at');
                if (subscriptionPriceEl) subscriptionPriceEl.style.display = isSubscribed ? '' : 'none';
                oneTimePriceEl.style.display = isSubscribed ? 'none' : '';
            } else {
                // Add-on / legacy cards: only the subscription state is discounted.
                const shouldShowSubscriptionPrice = Boolean(subscriptionPriceEl) && Boolean(isSubscribed);
                if (basePriceEl) basePriceEl.classList.toggle('compare-at', shouldShowSubscriptionPrice);
                if (subscriptionPriceEl) subscriptionPriceEl.style.display = shouldShowSubscriptionPrice ? '' : 'none';
            }
        });
    }

    function getActiveRecommendationQuantityInput(upsellItem) {
        if (!upsellItem) return null;

        const isAbCartDrawer = Boolean(upsellItem.closest('.ab-cart-drawer'));
        const activeSelector = isAbCartDrawer
            ? '.ab-cart-drawer__details-price-and-controls .quantity-input'
            : '.ab-cart-drawer__base-price-and-controls .quantity-input';

        return upsellItem.querySelector(activeSelector) ||
            upsellItem.querySelector('.firstday-cart__flyout-item-quantity .quantity-input');
    }

    // Serialize concurrent ATC clicks across the cart drawer's upsell cards.
    // Shopify's /cart/add.js locks the cart per request; firing two in parallel
    // can cause one to be silently dropped. Queue (not coalesce) — each click
    // is for a different upsell so all must run, just sequentially.
    let recommendationAddQueue = Promise.resolve();

    async function addRecommendationToCart(_variantId, triggerElement) {
        const next = recommendationAddQueue.then(() => _addRecommendationToCartImpl(_variantId, triggerElement));
        // Catch on the chain holder so one failure doesn't poison the queue.
        recommendationAddQueue = next.catch(() => {});
        return next;
    }

    // A placeholder line built from the card, shown while the add runs.
    function showPendingUpsellLine(upsellItem, quantity) {
        const container = document.getElementById('mini_cart_form');
        if (!container || !upsellItem) return null;
        const image = upsellItem.querySelector('.firstday-cart__flyout-item-media img');
        const titleEl = upsellItem.querySelector('.firstday-cart__flyout-item-product-title');
        const title = titleEl ? titleEl.textContent.trim() : '';
        const line = document.createElement('div');
        line.className = 'fd-cart-pending-line fd-bb-cart-skeleton__row';
        line.setAttribute('role', 'listitem');
        line.setAttribute('aria-busy', 'true');
        line.setAttribute('aria-label', `Adding ${title} to cart`);
        line.innerHTML =
            (image && image.getAttribute('src')
                ? `<span class="fd-bb-cart-skeleton__media fd-bb-cart-skeleton__media--image"><img src="${escapeHtmlAttr(image.getAttribute('src'))}" alt="" width="64" height="64"></span>`
                : '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__media"></span>') +
            '<span class="fd-bb-cart-skeleton__lines">' +
            `<span class="fd-bb-cart-skeleton__title">${escapeHtmlAttr((quantity > 1 ? quantity + 'x ' : '') + title)}</span>` +
            '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__bar fd-bb-cart-skeleton__bar--short"></span>' +
            '</span>' +
            '<span class="fd-bb-cart-skeleton__block fd-bb-cart-skeleton__price"></span>';
        container.insertBefore(line, container.firstChild);
        const emptyCartMessage = document.querySelector('.firstday-cart__flyout-empty-cart');
        const cartContent = document.querySelector('.firstday-cart__flyout-content');
        if (emptyCartMessage) emptyCartMessage.style.display = 'none';
        if (cartContent) cartContent.classList.add('has-items');
        return line;
    }

    async function _addRecommendationToCartImpl(_variantId, triggerElement) {
        let button = null;
        let upsellItem = null;

        if (triggerElement instanceof HTMLElement) button = triggerElement;

        if (!button && typeof event !== 'undefined' && event && event.target) {
            button = event.target.closest('button');
        }

        if (!button) {
            const escapedVariantId = String(_variantId).replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/'/g, "\\'");
            button = document.querySelector(`[onclick*="addRecommendationToCart"][onclick*="${escapedVariantId}"]`);
        }

        if (button) upsellItem = button.closest('.firstday-cart__flyout-item');

        let quantity = 1;

        if (upsellItem) {
            const quantityInput = getActiveRecommendationQuantityInput(upsellItem);

            if (quantityInput) {
                sanitizeRecommendationQuantity(quantityInput);

                const parsedQuantity = parseInt(quantityInput.value, 10);
                if (!Number.isNaN(parsedQuantity) && parsedQuantity > 0) {
                    quantity = parsedQuantity;
                }
            }
        }

        const dataset = (button && button.dataset) || {};
        const datasetVariantIds = STARTER_METAFIELD_KEYS
            .map(key => dataset[STARTER_METAFIELD_DATASET_KEYS[key]])
            .filter(Boolean)
            .map(normalizeVariantId)
            .filter(Boolean);

        let variantIdList = datasetVariantIds;

        // Starter packs (component variants from the Bundle entry) are tagged like
        // the PDP and product-card paths so the mini-cart renders one grouped card.
        const bundleProps = {};
        if (datasetVariantIds.length > 0) {
            const bundleTitle = dataset.productTitle || 'Starter Pack';
            bundleProps._bundle = 'starter-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
            bundleProps._bundle_title = bundleTitle;
            bundleProps._bundle_name = dataset.productTitle || '';
            if (dataset.productId) bundleProps._parent_pdp = String(dataset.productId);
            if (dataset.productHandle) bundleProps._parent_pdp_handle = String(dataset.productHandle);
        }

        if (!Array.isArray(variantIdList) || variantIdList.length === 0) {
            const fallbackVariantId = normalizeVariantId(_variantId);
            if (!fallbackVariantId) {
                console.error('No variant ID found for recommendation:', _variantId);
                return;
            }
            variantIdList = [fallbackVariantId];
        }

        const uniqueVariantIds = [];
        const seenVariantIds = new Set();

        variantIdList.forEach(id => {
            if (!seenVariantIds.has(id)) {
                seenVariantIds.add(id);
                uniqueVariantIds.push(id);
            }
        });

        if (!uniqueVariantIds.length) {
            console.error('No valid variant IDs resolved for recommendation add-to-cart');
            return;
        }

        if (typeof window.addToCart !== 'function') {
            console.error('window.addToCart is not available');
            return;
        }

        if (button && button.classList) {
            try {
                button.disabled = true;
                button.classList.add('loading');
                button.dataset.originalContent = button.innerHTML;
                button.innerHTML = '<span class="loading-spinner"></span> Adding...';
            } catch (err) {
                console.warn('Could not set button loading state:', err);
            }
        }

        const shouldSubscribe = (() => {
            if (!upsellItem) return false;
            const subscribeCheckbox = upsellItem.querySelector('.upsell-subscribe-checkbox');
            return Boolean(subscribeCheckbox && subscribeCheckbox.checked);
        })();

        // Add-on products are governed by a separate selling plan group than the
        // main subscription plan; sending STAY_SELLING_PLAN_ID for an add-on
        // variant makes Shopify reject /cart/add.js with 422. Detect via handle
        // (mirrors the PDP path in PBFCM-PDP-controller.js handleAddToCart).
        const productHandleForPlan = (button && button.dataset && button.dataset.productHandle) || '';
        const isAddOnUpsell = productHandleForPlan.includes('add-on');
        const resolvedSellingPlanId = (isAddOnUpsell && ADD_ON_SUBSCRIPTION_PLAN_ID)
            ? ADD_ON_SUBSCRIPTION_PLAN_ID
            : STAY_SELLING_PLAN_ID;

        const discountProps = (() => {
            const props = {};
            const cart = (latestCartState && Array.isArray(latestCartState.items)) ? latestCartState : null;
            const resolved = resolveEffectiveUpsellDiscount(cart);

            if (resolved.otpCode) props._otp_discount_code = String(resolved.otpCode);
            if (resolved.subCode) props._sub_discount_code = String(resolved.subCode);
            if (Number.isFinite(resolved.otpDiscountPercent)) {
                props._otp_discount_percentage = String(resolved.otpDiscountPercent);
            }
            if (Number.isFinite(resolved.subDiscountPercent)) {
                props._sub_discount_percentage = String(resolved.subDiscountPercent);
            }

            if (!props._otp_discount_code && !props._sub_discount_code) {
                applyGlobalUpsellDiscountProps(props);
            } else {
                props._discount_source = 'cart_upsells';
            }

            if (resolvedSellingPlanId) props._if_upgrade__selling_plan_id = String(resolvedSellingPlanId);

            return props;
        })();

        const items = uniqueVariantIds.map(id => {
            const item = {
                id,
                quantity,
                properties: {
                    "_full_price": "true",
                    "_product_type": "rebrand",
                    "_upsell_module": "cart_upsells",
                    "_page_path": window.location.pathname,
                    ...bundleProps,
                    ...discountProps
                }
            };

            if (shouldSubscribe) {
                if (resolvedSellingPlanId) item.selling_plan = resolvedSellingPlanId;
                item.properties["_is_subscription_purchase"] = "true";
            }
            if (isAddOnUpsell) item.properties._add_on = "true";

            return item;
        });

        const pendingLine = showPendingUpsellLine(upsellItem, quantity);
        let writeOpen = typeof beginCartWrite === 'function';
        if (writeOpen) beginCartWrite();
        const closeWrite = function () {
            if (writeOpen) endCartWrite();
            writeOpen = false;
        };
        let settleAction = null;
        if (typeof trackDrawerAction === 'function') {
            trackDrawerAction(new Promise(function (resolve) { settleAction = resolve; }));
        }

        try {
            let response = await window.addToCart({ items });

            // 422 with selling_plan typically means the global plan ID isn't valid
            // for this variant. Fall back to the product's own selling plan and retry once.
            if (!response.ok && response.status === 422 && shouldSubscribe && items.length > 0) {
                const fallbackPlanId = await getProductSellingPlanIdForVariant(productHandleForPlan, items[0].id);
                if (fallbackPlanId && fallbackPlanId !== String(resolvedSellingPlanId || '')) {
                    console.warn(`Mini cart: selling plan ${resolvedSellingPlanId} rejected; retrying with product-attached plan ${fallbackPlanId}`);
                    items.forEach(item => {
                        item.selling_plan = fallbackPlanId;
                        if (item.properties) item.properties._if_upgrade__selling_plan_id = fallbackPlanId;
                    });
                    response = await window.addToCart({ items });
                }
            }

            const data = await response.json();
            if (!response.ok) {
                const addError = new Error(data.description || data.message || 'Add failed');
                addError.status = response.status;
                addError.data = data;
                throw addError;
            }

            const updatedCart = window.FDCartApi
                ? await window.FDCartApi.getCart(true)
                : await fetch('/cart.js').then(r => r.json());

            preserveActiveUpsellCategory = true;
            closeWrite();
            await updateCartDisplay(updatedCart);
            
            if (typeof window.announceToScreenReader === 'function') {
                const productTitle = upsellItem?.querySelector('.firstday-cart__flyout-item-product-title')?.textContent?.trim() || 'Product';
                const itemCount = updatedCart.item_count || 0;
                const itemText = itemCount === 1 ? 'item' : 'items';
                window.announceToScreenReader(`${productTitle} added to cart. Cart now contains ${itemCount} ${itemText}.`);
            }
        } catch (error) {
            console.error('Error adding recommendation to cart:', error);
            closeWrite();
            if (pendingLine) pendingLine.remove();
            if (error && error.status && typeof rollbackDrawer === 'function') await rollbackDrawer(null);
            else if (typeof repaintFromServer === 'function') await repaintFromServer();

            if (typeof window.announceToScreenReader === 'function') {
                window.announceToScreenReader('Error adding item to cart. Please try again.', 'assertive');
            }
        } finally {
            if (pendingLine && pendingLine.parentNode) pendingLine.remove();
            if (settleAction) settleAction();
            if (button && button.classList) {
                try {
                    button.disabled = false;
                    button.classList.remove('loading');
                    if (button.dataset.originalContent) {
                        button.innerHTML = button.dataset.originalContent;
                        delete button.dataset.originalContent;
                    }
                } catch (err) {
                    console.warn('Could not remove button loading state:', err);
                }
            }
        }
    }

    function removeUpsellFromCart(variantId) {
        var removePromise = window.FDCartApi
            ? window.FDCartApi.changeLine(variantId, 0)
            : fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variantId, quantity: 0 })
            }).then(function (response) { return response.json(); });

        removePromise
            .then(function (updatedCart) {
                updateCartDisplay(updatedCart);
            })
            .catch(error => {
                console.error('Error removing upsell:', error);
            });
    }

    document.addEventListener('change', event => {
        const checkbox = event.target.closest('.upsell-subscribe-checkbox');
        if (!checkbox) return;

        const upsellItem = checkbox.closest('.firstday-cart__flyout-item');
        updateUpsellPriceDisplay(upsellItem, checkbox.checked);
    });

    document.addEventListener('click', event => {
        const tab = event.target.closest('.firstday-cart__flyout-recommendations__tabs .fd-tabs-v3__item');
        if (!tab || !tab.closest('.ab-cart-drawer')) return;

        activeUpsellCategory = tab.dataset.upsellCategory;
        applyUpsellCategoryFilter();
    });

    document.addEventListener('fd:offer-changed', function () {
        const cart = (typeof latestCartState !== 'undefined' && latestCartState)
            || (window.FDCart && typeof window.FDCart.getCart === 'function' && window.FDCart.getCart())
            || { items: [] };
        if (typeof populateEmptyCartStarterPacks === 'function') {
            populateEmptyCartStarterPacks(cart);
        }
        if (typeof populateRecommendations === 'function' && cart && Array.isArray(cart.items) && cart.items.length) {
            populateRecommendations(cart);
        }
    });
